import { React, RestaurantsContainer as Restaurants, hot, Layout, FelaComponent } from '../dependencies';
import Header from '../containers/Header';
import Background from './Background';
import LeftPanel from '../containers/LeftPanel';

const { Content } = Layout;
const layoutZindex = 5;

const layoutRule = () => ({
    background: 'transparent',
    position: 'relative',
    zIndex: layoutZindex,
    minHeight: '100vh',
});

const App = () => (
    <Background topics={['food']} zIndex={layoutZindex - 2}>
        <FelaComponent
            rule={layoutRule}
            render={({ className }) => (
                <Layout className={className}>
                    <Header />
                    <Content>
                        <Restaurants />
                    </Content>
                </Layout>
            )}
        />
        <LeftPanel />
    </Background>
);

export default hot(module)(App);
